import { useEffect } from "react";
import Lenis from "lenis";

let lenisInstance = null;

export function scrollToId(id) {
    const target = document.getElementById(id);
    if (!target) return;
    if (lenisInstance) {
        lenisInstance.scrollTo(target, { offset: -80, duration: 1.2 });
    } else {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
}

export default function SmoothScroll() {
    useEffect(() => {
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduce) return;
        const lenis = new Lenis({
            duration: 1.1,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            touchMultiplier: 1.6,
        });
        lenisInstance = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            lenisInstance = null;
        };
    }, []);
    return null;
}
